export enum ChatGroup {
    Editorial = 1,
    Global = 2,
}
